document.addEventListener("DOMContentLoaded", function () {
  // Tagueamento de visualização da página
  preencherLibSat("page_view", {
    event: "pageview:landing-page-crm-bonus:home:visualizou:tela",
    contentGroupping: "fin:landing-page-crm-bonus",
    page: "fin:landing-page-crm-bonus:home",
  });

  // Variáveis
  localStorage.setItem("pagina", "landing-page-crm-bonus");

  const botaoSimular1 = document.querySelector("#simulaButton1");
  const botaoSimular2 = document.querySelector("#simulaButton2");
  const cliqueAqui = document.querySelector("#cliqueAqui");
  const saibaMais = document.querySelector("#saibaMais");
  const baixarLista = document.querySelectorAll(".baixar");
  const listaFaq = document.querySelectorAll(".listafaq details");
  const imagemChevronAberto =
    "https://www.safrafinanceira.com.br/lumis-theme/br/com/safra/financeira/theme/safra-financeira/assets/images/veiculos/faq/arrow-up-black.svg";
  const imagemChevronFechado =
    "https://www.safrafinanceira.com.br/lumis-theme/br/com/safra/financeira/theme/safra-financeira/assets/images/veiculos/faq/arrow-down-black.svg";

  const dropdowns = document.querySelector(".listafaq");
  // const duvidas = [];

  if (botaoSimular1) {
    botaoSimular1.addEventListener("click", function (e) {
      e.preventDefault();

      preencherLibSat("click", {
        event: "event:landing-page-crm-bonus:home:clicou:botao:simular-agora-1",
        contentGroupping: "fin:landing-page-crm-bonus",
        page: "fin:landing-page-crm-bonus:home",
        eventCategory: "fin:landing-page-crm-bonus:home:body",
        eventAction: "clicou",
        eventLabel: "botao:simular-agora-1",
      });
      const href = botaoSimular1.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    });
  }
  if (botaoSimular2) {
    botaoSimular2.addEventListener("click", function (e) {
      e.preventDefault();

      preencherLibSat("click", {
        event: "event:landing-page-crm-bonus:home:clicou:botao:simular-agora-2",
        contentGroupping: "fin:landing-page-crm-bonus",
        page: "fin:landing-page-crm-bonus:home",
        eventCategory: "fin:landing-page-crm-bonus:home:body",
        eventAction: "clicou",
        eventLabel: "botao:simular-agora-2",
      });

      const href = botaoSimular2.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    });
  }

  if (cliqueAqui) {
    cliqueAqui.addEventListener("click", function (e) {
      e.preventDefault();

      preencherLibSat("click", {
        event:
          "event:landing-page-crm-bonus:home:clicou:botao:clique-aqui-regulamento",
        contentGroupping: "fin:landing-page-crm-bonus",
        page: "fin:landing-page-crm-bonus:home",
        eventCategory: "fin:landing-page-crm-bonus:home:header",
        eventAction: "clicou",
        eventLabel: "botao:clique-aqui-regulamento",
      });

      const href = cliqueAqui.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    });
  }

  if (saibaMais) {
    saibaMais.addEventListener("click", function (e) {
      e.preventDefault();

      preencherLibSat("click", {
        event:
          "event:landing-page-crm-bonus:home:clicou:botao:saiba-mais-confira-lojas-restaurantes",
        contentGroupping: "fin:landing-page-crm-bonus",
        page: "fin:landing-page-crm-bonus:home",
        eventCategory: "fin:landing-page-crm-bonus:home:body",
        eventAction: "clicou",
        eventLabel: "botao: saiba-mais-confira-lojas-restaurantes",
      });

      const href = saibaMais.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    });
  }

  for (let baixar of baixarLista) {
    if (baixar) {
      baixar.addEventListener("click", function (e) {
        // e.preventDefault();

        preencherLibSat("click", {
          event: "event:landing-page-crm-bonus:home:clicou:botao:baixe-app",
          contentGroupping: "fin:landing-page-crm-bonus",
          page: "fin:landing-page-crm-bonus:home",
          eventCategory: "fin:landing-page-crm-bonus:home:body",
          eventAction: "clicou",
          eventLabel: "botao:baixe-app",
        });

        // const href = baixar.getAttribute('href');
        // if (href && href !== '#') {
        //   window.location.href = href;
        // }
      });
    }
  }

  for (let details of listaFaq) {
    if (details) {
      details.addEventListener("toggle", function (e) {
        if (details.open) {
          // e.preventDefault();

          const duvida = details.children[0].textContent.trim();

          // duvidas.push(duvida);

          preencherLibSat("select", {
            event: "event:landing-page-crm-bonus:home:selecionou:duvidas",
            contentGroupping: "fin:landing-page-crm-bonus",
            page: "fin:landing-page-crm-bonus:home",
            eventCategory: "fin:landing-page-crm-bonus:home:body",
            eventAction: "selecionou",
            eventLabel: duvida,
            // eventLabel: duvidas
          });
        }
      });
    }
  }
  
function adicionaListenersToggle() {
  const detalhes = dropdowns.querySelectorAll("details");

  detalhes.forEach((detail) => {
    const img = detail.querySelector("summary img");
    img.src = imagemChevronFechado;
    console.log("entrou");
    detail.addEventListener("toggle", () => {
      if (detail.open) {
        img.src = imagemChevronAberto;
      } else {
        img.src = imagemChevronFechado;
      }
    });
  });
}

adicionaListenersToggle();
});

